<template>
   <div class="mb-5">
       <!-- Header section -->
       <header class="header-section-team header-section">
           <div class="container text-right">
               <div class="page-info">
                   <h2>За нас</h2>
                   <div class="page-links">
                       <router-link to="/">Начало</router-link>
                       <span class="active">За нас</span>
                   </div>
               </div>
           </div>
       </header>
       <div class="container mb-2 mt-5 about">
           <div class="row">
               <div class="col-md-6 mb-2">
                   <h4 class="text-center-mobile">За нас</h4>
                   <p>Ние сме екип от лекари, обединени от една обща цел: да бъдем до вас и вашето животно във всеки момент — от първата ваксина до грижата в напреднала възраст.
                   </p>
                   <p>Работим с внимание към детайла, с постоянен стремеж към развитие и с истинска любов към това, което правим.</p>
                   <h4 class="text-center-mobile mt-2">Какво ни отличава?</h4>
                   <p>Ние не просто лекуваме — ние слушаме, обясняваме и създаваме връзка. Подхождаме индивидуално към всяко животно и се стремим стопаните да се чувстват спокойни, информирани и подкрепени.</p>
                   <p>За нас ветеринарната грижа е партньорство, а доверието – най-ценното признание.</p>
               </div>
               <div class="col-md-6 mb-5">
                   <img style="border-radius: 20px;" src="../assets/images/CityJungle_Team_033-min.jpg" alt="" width="100%">
               </div>
               <div class="col-md-12">
                   <h2 class="text-center">Нашият екип</h2>
               </div>
               <div class="col-md-4 mt-4" v-for="user in Users" :key="user.key">
                   <div class="card">
                       <router-link style="color: #000; text-decoration: none;" :to="{name: 'detail', params: { id: user.key }}">
                           <div class="embed-responsive embed-responsive-1by1 rounded-image">
                               <img style="object-fit: cover;width: 100%;
height: auto;" :src="user.image" alt="" class="card-img-top embed-responsive-item">
                           </div>

                           <div class="card-body" style="max-height: 20vh; overflow: hidden;">
                               <h4>{{ user.name }}</h4>
                               <p :inner-html.prop="user.story | truncate(150, '...')"></p>
                           </div>
                       </router-link>
                   </div>
               </div>
           </div>
       </div>
       <!-- Header section end -->
   </div>
</template>

<script>
    import { db } from '../firebase';

    export default {
        data() {
            return {
                Users: []
            }
        },
        created() {
            db.collection('team').orderBy('order', 'asc').onSnapshot((snapshotChange) => {
                this.Users = [];
                snapshotChange.forEach((doc) => {
                    this.$options.filters.truncate(doc.data().story, 2, '...');
                    this.Users.push({
                        key: doc.id,
                        name: doc.data().name,
                        story: doc.data().story,
                        image: doc.data().image,
                    })
                    console.log(this.Users)
                });
            })
        },
        methods: {
            deleteUser(id){
                if (window.confirm("Do you really want to delete?")) {
                    db.collection("team").doc(id).delete().then(() => {
                        console.log("Document deleted!");
                    })
                        .catch((error) => {
                            console.error(error);
                        })
                }
            }
        },
        filters: {
            truncate: function (text, length, suffix) {
                if (text.length > length) {
                    return text.substring(0, length) + suffix;
                } else {
                    return text;
                }
            },
        }
    }
</script>
<style>
    .about {
        h4 {
            color: #66bfcb;
            font-weight: bold;
        }
    }
    .rounded-image {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
    }
    .card {
        border-radius: 20px;
        h4 {
            color: #1a1a1a;
            font-weight: normal;
        }
    }

    @media only screen and (max-width: 600px) {
        .text-center-mobile {
            text-align: center;
        }
    }
</style>
